module.exports = __webpack_public_path__ + "static/media/notfound.97ce509b.jpg";